module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/grunt/webpack/loaders/conditional?if=journey&equals=true!./common/js/src/edge/gateway/journey/gateway-journey-page.html
// module id = 528
// module chunks = 0